import { layout } from 'src/styles/layout';
import styled, { FlattenSimpleInterpolation, css, keyframes } from 'styled-components';

interface LogoShowcaseAutoScrollContainerProps {
  fadeElementColor: string;
}

const applyStylesToMobileStaticView = (styles: FlattenSimpleInterpolation): FlattenSimpleInterpolation => css`
  @media (max-width: ${layout.sm}) {
    ${styles}
  }
`;

const fadeElementStyles = css`
  content: '';
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 450px;
  height: 450%;
  border-radius: 50%;
  z-index: 2;
  filter: blur(20px);

  ${applyStylesToMobileStaticView(css`
    width: 150px;
  `)}
`;

export const ContainerRail = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
`;

export const LogoShowcaseAutoScrollContainer = styled.div<LogoShowcaseAutoScrollContainerProps>`
  width: 100%;
  position: relative;
  height: 50px;
  overflow: visible;
  z-index: 1;

  &:before {
    ${fadeElementStyles}
    left: -260px;
    transform: translateY(-50%) rotate(180deg);
    background: ${({ fadeElementColor }) => fadeElementColor};

    ${applyStylesToMobileStaticView(css`
      left: -80px;
    `)}
  }

  &:after {
    ${fadeElementStyles}
    right: -260px;
    background: ${({ fadeElementColor }) => fadeElementColor};

    ${applyStylesToMobileStaticView(css`
      right: -80px;
    `)}
  }
`;

const autoScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
`;

export const IconsRow = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  left: 0;
  bottom: 0;
  height: 100%;
  animation: ${autoScroll} 35s linear infinite;
`;

export const IconContainer = styled.div`
  margin: 0 1.5rem;
  display: flex;
  align-items: center;

  ${applyStylesToMobileStaticView(css`
    margin: 0 1rem;
  `)}
`;
